import { FC, useEffect } from 'react';
import { Checkbox } from 'antd';

import { FormLabel } from '../../components/FormLabel';
import { OR, PeriodSchedule } from './ScheduleTypes';
import { ACTION_TYPES } from './scheduleState/ScheduleReducer';
import { ReactComponent as ORIcon } from '../../assets/or-icon.svg';

type ORScheduleSelectorProps = {
  ORsList: OR[];
  periodSchedule: PeriodSchedule;
  hospitalDispatch: React.Dispatch<{ type: string; payload: any }>;
  selectedOR: string | null;
  setSelectedOR: (value: string | null) => void;
};

const ORScheduleSelector: FC<ORScheduleSelectorProps> = ({
  ORsList,
  hospitalDispatch,
  periodSchedule,
  selectedOR,
  setSelectedOR,
}) => {
  const updateORSelection = (checked: string | null) => {
    hospitalDispatch({
      type: ACTION_TYPES.UPDATE_PERIOD_PROPERTY,
      payload: {
        periodId: periodSchedule.id,
        property: 'applyToAllORs',
        updatedValue: checked === 'AllORs' ? true : false,
      },
    });

    if (checked) {
      setSelectedOR('AllORs');
    } else {
      setSelectedOR(ORsList?.[0].value || null);
    }
  };

  useEffect(() => {
    if (periodSchedule.applyToAllORs) {
      setSelectedOR('AllORs');
    } else {
      setSelectedOR(ORsList?.[0].value || null);
    }
  }, [periodSchedule.applyToAllORs]);

  return (
    <>
      <div>
        <Checkbox
          checked={periodSchedule.applyToAllORs}
          onChange={(e) => updateORSelection(e.target.checked ? 'AllORs' : null)}
        >
          <span className="font-bold mr-2">Apply to all ORs</span>
          {/* <ORIcon className="w-9 h-9 inline-block ml-2" /> */}
        </Checkbox>
      </div>
      {!periodSchedule.applyToAllORs && (
        <div className="w-9/12 mt-10">
          {/* <FormLabel>Operating Rooms</FormLabel> */}
          {ORsList.map((or, idx) => (
            <div
              className={`flex items-center h-16 rounded-md ${
                selectedOR == or.value ? 'bg-blue text-white' : 'bg-gray-100'
              } hover:bg-[#558EFD] hover:text-white pl-5 border-1 border-gray-200 mb-2 transition-all duration-300 cursor-pointer hover:shadow-md`}
              onClick={() => {
                setSelectedOR(or.value);
              }}
              key={idx}
            >
              {or.value}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default ORScheduleSelector;
